/*
 * Configurateur visuel Quooker — Madone (2026-10-17).
 * - Réservoir et CUBE pilotent les variantes natives : on coche le bouton radio natif
 *   correspondant, le thème gère prix, SKU, URL et médias.
 * - Cold Water Filter et accessoires sont ajoutés au panier dans la même requête native
 *   (/cart/add avec items[]) que le robinet, au moment où le formulaire du thème est soumis.
 * Sans JavaScript, le sélecteur natif du thème reste visible et fonctionnel.
 */
(() => {
  const root = document.querySelector('[data-qcfg]');
  if (!root || root.dataset.qcfgInit) return;
  root.dataset.qcfgInit = 'true';

  const read = (sel) => JSON.parse(root.querySelector(sel).textContent);
  const data = read('[data-qcfg-data]');
  const variants = read('[data-qcfg-variants]');
  const options = read('[data-qcfg-options]');
  const section = root.dataset.section;
  const model = root.dataset.model;
  const OPT = { finish: options.indexOf('Finition'), tank: options.indexOf('Réservoir'), cube: options.indexOf('CUBE') };
  if (OPT.finish < 0 || OPT.tank < 0 || OPT.cube < 0) return;

  const CUBE_WITH = 'Avec CUBE';
  const CUBE_WITHOUT = 'Sans CUBE';
  const money = (cents) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
  const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const form = () => document.getElementById(`product-form-${section}`);
  const currentVariant = () => {
    const id = Number(form()?.querySelector('[name="id"], [data-qcfg-name="id"]')?.value);
    return variants.find((v) => v.id === id) || variants[0];
  };
  const findVariant = (finish, tank, cube) =>
    variants.find((v) => v.options[OPT.finish] === finish && v.options[OPT.tank] === tank && v.options[OPT.cube] === cube);

  const v0 = currentVariant();
  const state = {
    finish: v0.options[OPT.finish],
    tank: v0.options[OPT.tank],
    water: v0.options[OPT.cube] === CUBE_WITH ? 'cube' : 'none',
    addons: new Set(),
    guide: {},
  };

  document.documentElement.classList.add('qcfg-ready');

  // ---- Synchronisation avec le sélecteur natif -------------------------------------------
  function selectNative(optionName, value) {
    const inputs = document.querySelectorAll(`variant-selects input[type="radio"]`);
    const input = [...inputs].find((i) => i.name.trim().startsWith(`${optionName}-`) && i.value === value);
    if (input && !input.checked) input.click();
  }
  function syncFromVariant() {
    const v = currentVariant();
    state.finish = v.options[OPT.finish];
    state.tank = v.options[OPT.tank];
    if (v.options[OPT.cube] === CUBE_WITH) state.water = 'cube';
    else if (state.water === 'cube') state.water = 'none';
    render();
  }
  document.addEventListener('change', (e) => {
    if (e.target.matches?.(`#product-form-${section} [name="id"]`)) syncFromVariant();
  });

  // ---- Calculs -----------------------------------------------------------------------------
  const tankDelta = (tank) => {
    const base = findVariant(state.finish, 'PRO3', CUBE_WITHOUT);
    const v = findVariant(state.finish, tank, CUBE_WITHOUT);
    return base && v ? v.price - base.price : 0;
  };
  const cubeDelta = () => {
    const a = findVariant(state.finish, state.tank, CUBE_WITHOUT);
    const b = findVariant(state.finish, state.tank, CUBE_WITH);
    return a && b ? b.price - a.price : 0;
  };
  const addonVariant = (addon) => (addon.byFinish ? addon.byFinish[state.finish] : addon.variant);
  function extras() {
    const list = [];
    if (state.water === 'cwf' && data.water.cwf.variant) list.push({ ...data.water.cwf.variant, title: data.water.cwf.title });
    for (const addon of data.addons) {
      if (!state.addons.has(addon.key)) continue;
      const v = addonVariant(addon);
      if (v) list.push({ ...v, title: addon.byFinish ? `${addon.title} ${state.finish.toLowerCase()}` : addon.title });
    }
    return list;
  }

  // ---- Rendu -------------------------------------------------------------------------------
  const delta = (cents) => (cents > 0 ? `+ ${money(cents)}` : cents < 0 ? `− ${money(-cents)}` : '');
  const card = ({ type, name, value, checked, img, title, price, text, badge }) => `
    <label class="qcfg-card${checked ? ' is-selected' : ''}">
      <input class="qcfg-card__input" type="${type}" name="${name}" value="${esc(value)}"${checked ? ' checked' : ''}>
      ${img ? `<img class="qcfg-card__img" src="${esc(img)}" alt="" width="64" height="64" loading="lazy">` : '<span class="qcfg-card__img qcfg-card__img--empty" aria-hidden="true"></span>'}
      <span class="qcfg-card__body">
        <span class="qcfg-card__head"><span class="qcfg-card__title">${esc(title)}</span>${badge ? `<span class="qcfg-badge">${esc(badge)}</span>` : ''}<span class="qcfg-card__price">${price || ''}</span></span>
        ${text ? `<span class="qcfg-card__text">${text}</span>` : ''}
      </span>
    </label>`;

  function recommendation() {
    if (state.guide.hot === 'no') return 'COMBI';
    if (state.guide.hot === 'yes' && state.guide.far === 'no') return 'PRO3';
    if (state.guide.hot === 'yes' && state.guide.far === 'yes') return 'COMBI+';
    return null;
  }
  const guideQuestion = (key, question) => `
    <fieldset class="qcfg-guide__q">
      <legend>${esc(question)}</legend>
      ${['yes', 'no'].map((a) => `<label class="qcfg-chip${state.guide[key] === a ? ' is-selected' : ''}"><input type="radio" name="qcfg-guide-${key}" value="${a}"${state.guide[key] === a ? ' checked' : ''}>${a === 'yes' ? 'Oui' : 'Non'}</label>`).join('')}
    </fieldset>`;

  function render() {
    const rec = recommendation();
    const t = data.tanks;
    const lines = [];
    const tapVariant = findVariant(state.finish, state.tank, CUBE_WITHOUT);
    if (tapVariant) lines.push([`${model} · ${state.finish}`, `Réservoir ${state.tank}`, tapVariant.price]);
    if (state.water === 'cube') lines.push([data.water.cube.title, '', cubeDelta()]);
    const ex = extras();
    for (const x of ex) lines.push([x.title, '', x.price]);
    const total = lines.reduce((s, l) => s + l[2], 0);

    root.querySelector('[data-qcfg-render]').innerHTML = `
      <section class="qcfg-block">
        <p class="qcfg-step"><span>Étape 2</span> Votre réservoir sous l’évier</p>
        <details class="qcfg-guide"${state.guide.open ? ' open' : ''}>
          <summary>Quel réservoir est fait pour moi ? <span>Répondez à 2 questions</span></summary>
          <div class="qcfg-guide__body">
            ${guideQuestion('hot', data.guide.hot)}
            ${state.guide.hot === 'yes' ? guideQuestion('far', data.guide.far) : ''}
            ${rec ? `<p class="qcfg-guide__result">Notre conseil : <strong>${esc(rec)}</strong>. ${esc(data.guide.why[rec])}</p>` : ''}
          </div>
        </details>
        <div class="qcfg-cards">
          ${data.tankOrder.map((k) => card({ type: 'radio', name: 'qcfg-tank', value: k, checked: state.tank === k, img: t[k].img, title: t[k].title, price: delta(tankDelta(k)), text: t[k].text, badge: rec === k ? 'Conseillé' : '' })).join('')}
        </div>
        <details class="qcfg-compare">
          <summary>Comparer les réservoirs</summary>
          <div class="qcfg-compare__scroll"><table>
            <thead><tr><th></th>${data.tankOrder.map((k) => `<th>${esc(t[k].title)}</th>`).join('')}</tr></thead>
            <tbody>${data.compare.map((row) => `<tr><th>${esc(row[0])}</th>${row.slice(1).map((c) => `<td>${esc(c)}</td>`).join('')}</tr>`).join('')}</tbody>
          </table></div>
        </details>
      </section>
      <section class="qcfg-block">
        <p class="qcfg-step"><span>Étape 3</span> Eau filtrée, réfrigérée et pétillante</p>
        <p class="qcfg-lead">${esc(data.water.lead)}</p>
        <div class="qcfg-cards">
          ${card({ type: 'radio', name: 'qcfg-water', value: 'none', checked: state.water === 'none', title: data.water.none.title, text: esc(data.water.none.text) })}
          ${data.water.cwf.variant ? card({ type: 'radio', name: 'qcfg-water', value: 'cwf', checked: state.water === 'cwf', img: data.water.cwf.img, title: data.water.cwf.title, price: delta(data.water.cwf.variant.price), text: esc(data.water.cwf.text) }) : ''}
          ${card({ type: 'radio', name: 'qcfg-water', value: 'cube', checked: state.water === 'cube', img: data.water.cube.img, title: data.water.cube.title, price: delta(cubeDelta()), text: esc(data.water.cube.text) })}
        </div>
      </section>
      <section class="qcfg-block">
        <p class="qcfg-step"><span>Étape 4</span> Accessoires assortis <em>facultatif</em></p>
        <div class="qcfg-addons">
          ${data.addons.map((a) => {
            const v = addonVariant(a);
            if (!v) return '';
            const on = state.addons.has(a.key);
            return `<label class="qcfg-addon${on ? ' is-selected' : ''}">
              <input class="qcfg-card__input" type="checkbox" name="qcfg-addon" value="${esc(a.key)}"${on ? ' checked' : ''}>
              <img src="${esc(a.byFinishImg?.[state.finish] || a.img)}" alt="" width="96" height="96" loading="lazy">
              <span class="qcfg-addon__title">${esc(a.byFinish ? `${a.title} ${state.finish.toLowerCase()}` : a.title)}</span>
              <span class="qcfg-addon__text">${esc(a.text)}</span>
              <span class="qcfg-addon__foot"><span>${money(v.price)}</span><span class="qcfg-addon__cta">${on ? 'Ajouté ✓' : 'Ajouter'}</span></span>
            </label>`;
          }).join('')}
        </div>
      </section>
      <section class="qcfg-summary" aria-live="polite">
        <p class="qcfg-summary__title">Votre système Quooker</p>
        <ul>${lines.map(([a, b, p]) => `<li><span>${esc(a)}${b ? `<small>${esc(b)}</small>` : ''}</span><span>${money(p)}</span></li>`).join('')}</ul>
        <p class="qcfg-summary__total"><span>Total</span><span>${money(total)}</span></p>
        <p class="qcfg-summary__note">${esc(data.summaryNote)}</p>
      </section>`;
  }

  root.addEventListener('change', (e) => {
    const el = e.target;
    if (el.name === 'qcfg-tank') { state.tank = el.value; selectNative(options[OPT.tank], el.value); }
    else if (el.name === 'qcfg-water') {
      state.water = el.value;
      selectNative(options[OPT.cube], el.value === 'cube' ? CUBE_WITH : CUBE_WITHOUT);
    } else if (el.name === 'qcfg-addon') { el.checked ? state.addons.add(el.value) : state.addons.delete(el.value); }
    else if (el.name.startsWith('qcfg-guide-')) {
      state.guide[el.name.replace('qcfg-guide-', '')] = el.value;
      if (el.name === 'qcfg-guide-hot') delete state.guide.far;
      state.guide.open = true;
      const rec = recommendation();
      if (rec && rec !== state.tank) { state.tank = rec; selectNative(options[OPT.tank], rec); }
    } else return;
    render();
  });
  root.addEventListener('toggle', (e) => { if (e.target.matches('.qcfg-guide')) state.guide.open = e.target.open; }, true);

  // ---- Ajout au panier groupé (requête native du thème) -----------------------------------
  document.addEventListener('submit', (e) => {
    const f = e.target;
    if (f.getAttribute?.('id') !== `product-form-${section}`) return;
    const list = extras();
    if (!list.length) return;
    const idInput = f.querySelector('input[name="id"]');
    const qtyInput = f.querySelector('input[name="quantity"]');
    if (!idInput) return;
    const add = (n, v) => { const i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; i.dataset.qcfgTemp = ''; f.appendChild(i); };
    add('items[0][id]', idInput.value);
    add('items[0][quantity]', qtyInput?.value || 1);
    list.forEach((x, k) => { add(`items[${k + 1}][id]`, x.id); add(`items[${k + 1}][quantity]`, 1); });
    for (const input of [idInput, qtyInput]) if (input) { input.dataset.qcfgName = input.name; input.removeAttribute('name'); }
    setTimeout(() => {
      f.querySelectorAll('[data-qcfg-temp]').forEach((i) => i.remove());
      f.querySelectorAll('[data-qcfg-name]').forEach((i) => { i.name = i.dataset.qcfgName; delete i.dataset.qcfgName; });
    }, 0);
  }, true);

  render();
})();
